export default __webpack_public_path__ + "static/media/keep-booking.cd84cb4b.png";